module.exports = __webpack_public_path__ + "97e44b151627ec35e1d03820f4b58682.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_history_nav.svg
// module id = 280
// module chunks = 0